import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/account/auth.service';
import { User } from 'src/app/core/account/user.model';
import { MemberSearchService } from 'src/app/shared/member-search/member-search.service';
import { FollowupService } from 'src/app/shared/services/followup.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { DepartmentService } from '../department/department.service';
import { GroupRequestService } from '../group-request/group-request.service';
import { MembershipService } from '../membership/membership.service';
import { SuperGroupService } from '../super-group/super-group.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';

@Component({
    selector: 'app-admin-setup',
    templateUrl: './admin-setup.component.html',
    styleUrls: ['./admin-setup.component.scss'],
    standalone: false
})
export class AdminSetupComponent implements OnInit, AfterViewInit {
  membershipLoading: boolean = true;
  taskNotificationCount: number = 0;
  isLoading: boolean = true;
  requests: number;
  grpRequests: number;
  donationLink: string = null;
  birthdayCount: number = 0;
  churchWebsite: string = null;
  Test: boolean = true;
  taskCount: number = 0;
  depCount: number = 0;
  supCount: number = 0;

  cmsModule: boolean = false;
  user: User;

  constructor(
    public globalService: GlobalService,
    public authService: AuthService,
    public identityService: IdentityService,
    private membershipService: MembershipService,
    private groupRequestService: GroupRequestService,
    public tenantService: TenantService,
    private memberSearchService: MemberSearchService,
    private _router: Router,
    private followupService: FollowupService,
    private departmentService: DepartmentService,
    private superGroupService: SuperGroupService,
    private linkHandler: LinkHandlerService
  ) {
  }
   
  async ngOnInit() {
    await this.loadMenu(true);
  }

  protected async loadMenu(resetPage: boolean) {
    this.isLoading = true; 

    if (resetPage) this.globalService.reset();
    this.user = await this.authService.autoLogin(1);
    var tenantData = await this.tenantService.getSimpleTenant();
    this.cmsModule = tenantData.cmsModule;
    this.donationLink = tenantData.donationLink;
    this.churchWebsite = tenantData.churchWebsite;
    if (this.user == null)
    {
      this.isLoading = false;
      this._router.navigate([this.globalService.subdomain + '/login']);
    }
    else
    {
      await this.CallBirthdayData(); 
      this.taskCount = await this.followupService.GetFollowupsCount(
        this.identityService.memberId
      );
      this.taskNotificationCount = await this.followupService.GetNotificationsCount(
        this.identityService.memberId
      )
      // this.identityService.loadUser(this.user);
      if (this.identityService.permissions == null) {
        this.membershipLoading = false;
        this.identityService.authenticated = false;
        this.identityService.permissions = [];
        this.authService.logout(1);
        this._router.navigate([this.globalService.subdomain + '/login']);
      }
      else   
      {
        await this.CallMembershipRequestsData();
        await this.CallGroupRequestsData();
        var deps = await this.departmentService.getAllDepartments();
        var sups = await this.superGroupService.getAllSuperGroups();
        this.depCount = deps == null ? 0 : deps.length;
        this.supCount = sups == null ? 0 : sups.length;
        this.isLoading = false;
      }
    } 
  }

  // Footer navigation already has an authenticated identity and loaded church data.
  // Counters are supplementary and must never block opening the menu.
  protected async loadFooterCounters(): Promise<void> {
    const jobs: Promise<unknown>[] = [];
    const load = (request: () => Promise<any>, apply: (data: any) => void) => {
      jobs.push(Promise.resolve().then(request).then(apply).catch(error => {
        if (error?.status === 401) this.CallLogout();
      }));
    };
    if (this.identityService.hasBirthday()) {
      const filter = this.memberSearchService.initializeFilter();
      filter.birthdayDay = new Date().getDate();
      filter.birthdayMonth = new Date().getMonth() + 1;
      load(() => this.memberSearchService.AdvancedSearch(filter, 'pageNumber=1&pageSize=20', true),
        data => this.birthdayCount = data?.totalRecords ?? 0);
    }
    if (this.identityService.hasMembershipRequests()) {
      load(() => this.membershipService.getMembershipRequests(), data => this.requests = data?.length ?? 0);
    }
    if (this.identityService.hasGroupAdmin()) {
      load(() => this.groupRequestService.getGroupRequests(), data => this.grpRequests = data?.dataResult?.length ?? 0);
      load(() => this.departmentService.getAllDepartments(), data => this.depCount = data?.length ?? 0);
      load(() => this.superGroupService.getAllSuperGroups(), data => this.supCount = data?.length ?? 0);
    }
    if (this.identityService.hasTaskAssignment()) {
      load(() => this.followupService.GetFollowupsCount(this.identityService.memberId), data => this.taskCount = data ?? 0);
      load(() => this.followupService.GetNotificationsCount(this.identityService.memberId), data => this.taskNotificationCount = data ?? 0);
    }
    await Promise.all(jobs);
  }

  collapseAllAccordions() {
    const elements = document.querySelectorAll('#MainMenu .collapse.show');
      elements.forEach((el: any) => {
          el.classList.remove('show');
      });
}

  ngAfterViewInit() {
    setTimeout(() => {
    if (this.globalService.isBack == false)
      this.globalService.title.push(this.globalService.screenHeader);      
    this.globalService.selectedOption = "SYSTEM_MENU";    
    this.globalService.screenHeader = this.globalService.Get('SYSTEM_MENU');
    });
  }



  async CallMembershipRequestsData() {
    this.collapseAllAccordions();
    await this.membershipService
      .getMembershipRequests()
      .then((data) => {
        this.requests = data.length;
        this.membershipLoading = false;
      })
      .catch((error) => {
        this.membershipLoading = false;
        if (error?.status === 401) {
          this.authService.logout(1);
          this._router.navigate([this.globalService.subdomain + '/login']);
        }
      });
  }
  
  callPointSystem()
  {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/list-point-systems']);
  }

  CallLogout() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this.membershipLoading = false;
    this.identityService.authenticated = false;
    this.identityService.permissions = [];

    this.authService.logout(1);
    this._router.navigate([this.globalService.subdomain + '/login']);
  }


  async CallGroupRequestsData() { 
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    await this.groupRequestService
      .getGroupRequests()
      .then((data) => {
        this.grpRequests = data['dataResult'].length;
        this.membershipLoading = false;
        // this.isLoading = false;
      })
      .catch((error) => {
        this.membershipLoading = false;
        if (error?.status === 401) {
          this.authService.logout(1);
          this._router.navigate([this.globalService.subdomain + '/login']);
        }
      });
  }

  async CallBirthdayData() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this.memberSearchService.filter =
      this.memberSearchService.initializeFilter();
    this.memberSearchService.filter.birthdayDay = new Date().getDate();
    this.memberSearchService.filter.birthdayMonth = new Date().getMonth() + 1;
    var results = await this.memberSearchService.AdvancedSearch(
      this.memberSearchService.filter,
      'pageNumber=1&pageSize=20', true
    ).catch(() => null);
    this.birthdayCount = results?.['totalRecords'] ?? 0;
  }

  CallFormBuilder() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/edit-form']); 
  }

  CallFormData() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/list-forms']);
  }

  CallTags() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/admin-setup/tags']);
  }  

  CallLinks() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/admin-setup/links']);
  }

  CallServiceGroup() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/admin-setup/service-group']);
  }

  CallServiceVenue() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/admin-setup/service-venue']);
  }

  CallRegistrationGroup() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/admin-setup/registration-group']);
  }

  CallServiceSetup() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this.globalService.serviceFilter = '';
    this.globalService.serviceHidden = false; 
    this._router.navigate(['/admin/service']);
  }

  CallMemberPermission() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/permissions']);
  }

  CallViewAccount() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/edit-account']);
  }

  CallCongregationCheckin(): void {
    if (!this.identityService.hasCheckIn()) return;
    this.globalService.Initialize();
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    this._router.navigate(['/usher/check-in']);
  }

  CallAttendance() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/attendance']);
  }

  CallFundTypes() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/fund-types']); 
  }

  CallDonationReport() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/report/donation']);
  }

  CallNotes() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/notes']);
  }

  CallFollowup() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/followup']);
  }

  CallBirthday() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/birthday']);
  }

  CallTasks() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/tasks']);
  } 

  CallContentTranslations(){this._router.navigate([this.globalService.subdomain+'/admin/content-translations']);}
  CallCMS() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/' + this.globalService.subdomain + '/admin/content-studio']);
  }

  CallMyTasks() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/mytasks']);
  } 

  CallEventReport() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this.globalService.serviceGroupId = 0;
    this.globalService.serviceVenueId = 0;
    this.globalService.eventDate = null;
    this._router.navigate(['/admin/view-event']);
  }

  CallCommunication() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/communication']);
  }

  CallMembership() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/membership']);
  }

  CallGroupRequests() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/group/requests']);
  }

  CallDepartment() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/department']);
  }

  CallSuperGroups() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/super-groups']);
  }

  CallGroups() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/groups']);
  }

  CallChurches() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/churches']);
  }

  setTest() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this.Test = !this.Test;
  }

  getWebsite() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    //window.open(this.churchWebsite, 'self');
    this.linkHandler.open(this.churchWebsite);
  }

  getDonationLink() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    //window.open(this.donationLink, 'self');
    this.linkHandler.open(this.donationLink);
  }

  CallMyProfile() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/myprofile']);
  }

  CallCalendar() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/member/select-service/1']);
  }

  CallMyRegistrations() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/member/select-service/2']);
  }

  CallMyGroups() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/groups']);
  }

  CallMyForms() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/forms']);
  }

  CallVolunteering() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/volunteering']);
  }  

  CallImport() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/import']);
  }

  CallNotifications() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/notifications']);
  }

  CallActivityChart() {
    this.collapseAllAccordions();
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/report/activity']);
  }

  CallMapDistribution() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/report/distribution']); 
  }

  CallSelectiveCommunication() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/report/communication']); 
  }

  CallDataDownload() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/report/data-download']); 
  }

  CallDemographicsChart() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/report/demographics']); 
  }

  CallShowSubscription() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/show-subscription']); 
  }

  CallMyChurch() {
    this.collapseAllAccordions();
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/my-church']);
  }

  CallCommunicationPage() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/admin/communication-options']);
  }

  MyDonations() {
    this.collapseAllAccordions();    
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;

    this._router.navigate(['/my-donations']);
  }

CallPaymentAdapters() {

  this._router.navigate([
    this.globalService.subdomain +
    '/admin/view-payment-adapters'
  ]);
}  
}
